// Mirrors _features/plans/state/slice.js's shape (selectedFilters +
// customColumns, REHYDRATE normalization) - does NOT carry forward the old
// features/MarketsFeature/slice.js's `markets` mirror (write-only
// dead-sync within THIS feature - nothing outside MarketsFeature ever read
// state.marketsFeature.markets; useMarketsData already returns straight
// from the RTK Query cache).
import { createSlice } from "@reduxjs/toolkit";
import { REHYDRATE } from "redux-persist";

const initialState = {
  selectedFilters: {
    sort: "-createdAt",
  },
};

const marketsFeatureSlice = createSlice({
  name: "marketsFeature",
  initialState,
  reducers: {
    updateSelectedFilters: (state, action) => {
      state.selectedFilters = action.payload;
    },
    resetSelectedFilters: (state) => {
      state.selectedFilters = {
        sort: "-createdAt",
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(REHYDRATE, (state, action) => {
      if (action.payload && action.payload.marketsFeature) {
        const persistedData = action.payload.marketsFeature;
        const persistedSort = persistedData.selectedFilters?.sort;

        return {
          ...state,
          ...persistedData,
          selectedFilters: {
            ...persistedData.selectedFilters,
            sort: persistedSort || "-createdAt",
          },
        };
      }
      return state;
    });
  },
});

export const { updateSelectedFilters, resetSelectedFilters } =
  marketsFeatureSlice.actions;

export default marketsFeatureSlice.reducer;
